import React, { useState, useLayoutEffect, useRef } from 'react';

export const LanderIntro = ({ logo, blurb }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const blurbRef = useRef(null);

  const LINE_HEIGHT = 32;
  const MAX_LINES = 7;
  const THRESHOLD = LINE_HEIGHT * MAX_LINES;

  useLayoutEffect(() => {
    const element = blurbRef.current;
    if (!element) return;

    // Create an observer to check overflow whenever the element's size changes
    const resizeObserver = new ResizeObserver(() => {
      setIsOverflowing(element.scrollHeight > THRESHOLD);
    });

    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [blurb, THRESHOLD]);

  return (
    <div className="lander-intro-container">
      <div className="lander-content-wrapper">
        <img 
          className="lander-bug" 
          src={logo} 
          alt="Lander Intro Bug"
        />
        <div 
          ref={blurbRef}
          className={`lander-blurb ${isExpanded ? 'expanded' : 'collapsed'}`} 
          style={{ 
            WebkitBoxOrient: isExpanded ? "unset" : "vertical",
            display: isExpanded ? "block" : "-webkit-box",
            WebkitLineClamp: isExpanded ? "none" : MAX_LINES,
            overflow:isExpanded ? "unset" : "hidden",
            fontSize: "19px",
            lineHeight: `${LINE_HEIGHT}px`,
            fontFamily: "Tiempos"
          }}
          dangerouslySetInnerHTML={{ __html: blurb }}
        />
      </div>
      {/* Only render the toggle if the text actually overflows 7 lines */}
      {isOverflowing && (
        <div className="toggle-button">
          <div 
            className="toggle-button-text" 
            onClick={() => setIsExpanded(!isExpanded)}
            style={{ cursor: 'pointer' }}
          > 
            {isExpanded ? "- Show Less" : "+ Show More"} 
          </div>
        </div>
      )}
    </div>
  );
};